import { makeAutoObservable } from "mobx"

class CommonStore {
  recommendedId = 0
  recommendedModal = false
  recommendedAutoplay = true
  recommendedSelectedPlan = ""
  recommendedJourney = false
  recommendedGetPer = 8
  keyTermsId = 2
  keyTermsAutoPlay = false
  keyTermName = ""
  WhatIsId = 0
  WhatIsAutoPlay = true
  WhatIsModal = false
  DYKId = 0
  StoryModal = false
  selectedIllustration = "Illustration1"
  FPexpId = null
  FP_SelectedItem = "VEEF" // Value Enhancer Fund For All
  mythBusterModal = false
  planWorksTab = 0
  expertModal = false

  constructor() {
    makeAutoObservable(this)
  }

  setRecommendedId = (data) => (this.recommendedId = data)
  setRecommendedModal = (data) => (this.recommendedModal = data)
  setRecommendedAutoplay = (data) => (this.recommendedAutoplay = data)
  setRecommendedSelectedPlan = (data) => (this.recommendedSelectedPlan = data)
  setRecommendedGetPer = (data) => (this.recommendedGetPer = data)
  setRecommendedJourney = (data) => (this.recommendedJourney = data)
  setkeyTermsId = (data) => (this.keyTermsId = data)
  setkeyTermsAutoPlay = (data) => (this.keyTermsAutoPlay = data)
  setkeyTermName = (data) => (this.keyTermName = data)
  setWhatIsId = (data) => (this.WhatIsId = data)
  setWhatIsModal = (data) => (this.WhatIsModal = data)
  whatIsTermsAutoPlay = (data) => (this.WhatIsAutoPlay = data)

  setDYKId = (data) => (this.DYKId = data)

  setStoryModal = (data) => (this.StoryModal = data)
  setSelectedIllustation = (data) => (this.selectedIllustration = data)
  setmythBusterModal = (data) => (this.mythBusterModal = data)
  setplanWorksTab = (data) => (this.planWorksTab = data)
  setFPexpId = (data) => (this.FPexpId = data)
  setFPSelectedItem = (data) => (this.FP_SelectedItem = data)
  setexpertModal = (data) => (this.expertModal = data)
}

export default new CommonStore()
